/**
 * Wraps a product NAME in a link to its Amazon listing (Faraz: "all product
 * names, everywhere, should be a clickable link to the Amazon listing").
 * Renders plain text when there's no ASIN (unmapped/unsynced SKU) — never a
 * dead link. `stopPropagation` matters: several names sit inside clickable
 * row buttons (expanders) — the link must not also toggle the row.
 */
import type { ReactNode } from 'react';
import { cn } from '../design';

interface ProductLinkProps {
  asin: string | null;
  children: ReactNode;
  className?: string;
}

export function ProductLink({ asin, children, className }: ProductLinkProps) {
  if (!asin) {
    return <span className={className}>{children}</span>;
  }
  return (
    <a
      href={`https://www.amazon.com/dp/${asin}`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className={cn(className, 'hover:underline decoration-fg-tertiary underline-offset-2')}
    >
      {children}
    </a>
  );
}
